import { render, staticRenderFns } from "./LocalLifeScreen.vue?vue&type=template&id=67c441a4&scoped=true"
import script from "./LocalLifeScreen.vue?vue&type=script&lang=js"
export * from "./LocalLifeScreen.vue?vue&type=script&lang=js"
import style0 from "./LocalLifeScreen.vue?vue&type=style&index=0&id=67c441a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c441a4",
  null
  
)

export default component.exports